/* eslint @typescript-eslint/naming-convention: 0 */
import { buildSelectTagInSearchModalParams } from '@/wabunka-src/common/utils/googleAnalytics/common/selectTag';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export const sendGAWabunkaSelectDestinationInSearchModalEvent = (tag: string) => {
  sendWabunkaGAEvent('select_destination_in_search_modal', buildSelectTagInSearchModalParams(tag));
};
